module.exports = __webpack_public_path__ + "img/media_and_awards_bg.5d191fe2.jpg";